<template>
  <div>
    <v-card
      flat
      class="pa-3 mt-2"
    >

      <v-card-text>
        <v-form ref="form" class="multi-col-validation mt-6">
          <v-row>
            <v-card
              flat
            >
              <v-toolbar dense dark color="primary">
                <v-toolbar-title><h4 class="font-weight-light">TYPE OF SERVICE</h4>
                </v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-row class="mt-4">
                  <v-col
                    md="12"
                    cols="12"
                  >
                    <v-text-field
                      v-model="last_name"
                      label="Type of Service"
                      dense
                      outlined
                      :rules="rules.default_max_45_character_and_no_empty_rule"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    md="12"
                    cols="12"
                  >

                    <v-select
                      v-model="mode"
                      class="mx-2"
                      dense
                      label="Mode of Service"
                      :items="['Annual','Semi-Annual','Quarterly','Semi-Monthly','2-Month','Monthly','Weekly','Daily','Supply/Beverages']"
                    ></v-select>
                  </v-col>
                  <v-col
                    md="3"
                    cols="12"
                  >
                    <v-text-field
                      v-model="amount_for_member"
                      label="Amount for Member"
                      dense
                      outlined
                      :rules="rules.default_max_45_character_and_no_empty_rule"
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    md="3"
                    cols="12"
                  >
                    <v-text-field
                      v-model="amount_for_non_member"
                      label="Amount for Non Member"
                      dense
                      outlined
                      :rules="rules.default_max_45_character_and_no_empty_rule"
                      type="number"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <!-- alert -->
            <v-col cols="12" v-show="alert">
              <v-alert
                color="warning"
                text
                class="mb-0"

              >
                <div class="d-flex align-start">
                  <v-icon color="warning">
                    {{ icons.mdiAlertOutline }}
                  </v-icon>

                  <div class="ms-3">126009
                    <p class="text-base font-weight-medium mb-1">
                      {{ alert_message }}
                    </p>
                  </div>
                </div>
              </v-alert>
            </v-col>

            <v-col cols="12" v-if="!is_deleting">
              <v-btn
                color="primary"
                class="me-3 mt-4"
                @click="save_employee"
                v-if="!saving"
              >
                Save changes
              </v-btn>
              <v-progress-circular
                :size=50
                :width="5"
                color="primary"
                indeterminate
                v-else
              ></v-progress-circular>
            </v-col>

            <v-col cols="12" v-if="is_deleting">
              <v-btn
                color="primary"
                class="me-3 mt-4"
                @click="save_employee"
                v-if="!saving"
              >
                Update changes
              </v-btn>
              <v-progress-circular
                :size=50
                :width="5"
                color="primary"
                indeterminate
                v-else
              ></v-progress-circular>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-data-table dense
                    :headers="headers"
                    :items="data_items"
                    hide-default-footer
                    disable-pagination
                    class="mt-3"
      >
        <template v-slot:item.status="{ item }">
          <tr>
            <td>
              <v-chip
                v-if="item.is_active===1"
                small
                color="success"
                class="font-weight-medium"
              >
                ACTIVE
              </v-chip>
              <v-chip
                v-else
                small
                color="error"
                class="font-weight-medium"
              >
                DEACTIVATE
              </v-chip>
            </td>
          </tr>
        </template>
        <template v-slot:item.action="{ item }">
          <tr>
            <td class="text-center">
              <div>
                <v-icon
                  v-if="!is_deleting"
                  class="mr-2"
                  color="info"
                  @click="edit_service(item)"
                >
                  {{ icons.mdiPencil }}
                </v-icon>
                <v-progress-circular color="info" indeterminate
                                     v-if="is_deleting"></v-progress-circular>
              </div>
              <div>
                <v-icon
                  v-if="!is_deleting && item.is_active===1"
                  class="mr-2"
                  color="warning"
                  @click="update_service(item,0)"
                >
                  {{ icons.mdiDelete }}
                </v-icon>
                <v-icon
                  v-if="!is_deleting && item.is_active===0"
                  class="mr-2"
                  color="success"
                  @click="update_service(item,1)"
                >
                  {{ icons.mdiCheck }}
                </v-icon>
                <v-progress-circular color="info" indeterminate
                                     v-if="is_deleting"></v-progress-circular>
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>


    <snack-bar-dialog
      :snackbar_flag="this.snackbar"
      :color="this.snackbar_color"
      :snackbar_text="this.snackbar_text"
    />
  </div>
</template>

<script>
import {mdiAlertOutline, mdiCloudUploadOutline, mdiPencil,mdiDelete,mdiCheck} from '@mdi/js'
import 'croppie/croppie.css'// import the croppie css manually
import {mapGetters, mapActions} from "vuex";
import moment from 'moment'
import snackBarDialog from '@/components/dialogs/notifications_dialog/Snackbar'

const initialState = () => {
  return {
    show: false,
    avatarImg: require('@/assets/images/avatars/1.png'),

    saving: false,
    alert: false,
    alert_message: '',
    croppieImage: '',
    cropped: require('@/assets/images/avatars/1.png'),

    category_id: '',
    mode: '',
    category_items: [],
    branch_id: '',
    branch_items: [],
    employee_position_id: '',
    position_items: [],
    last_name: '',
    first_name: '',
    middle_name: '',
    date_of_birth: '',
    gender: '',
    civil_status: '',
    religion: '',
    date_of_employment: '',
    compensation_rate: 0,
    is_allowance_only: false,
    is_deleting: false,
    bank_type_1: '',
    bank_account_1: '',
    bank_account_no_1: '',
    bank_type_2: '',
    bank_account_2: '',
    bank_account_no_2: '',
    bank_type_3: '',
    bank_account_3: '',
    bank_account_no_3: '',
    sss_no: '',
    ph_no: '',
    pag_ibig_no: '',
    tin_no: '',
    emergency_name: '',
    emergency_address: '',
    emergency_contact_no: '',
    address: '',
    region_id: '',
    province_id: '',
    branch_city_id: '',
    region_items: [],
    province_items: [],
    branch_city_items: [],
    data_items: [],
    email_address: '',
    id: '',
    amount_for_member: '',
    amount_for_non_member: '',
    headers: [
      {text: 'ID', value: 'id', sortable: false},
      {text: 'Type of Service', value: 'type_of_service', sortable: false},
      {text: 'Mode of Service', value: 'mode_of_service', sortable: false},
      {text: 'Amount for Member', value: 'amount_for_member', sortable: false},
      {text: 'Amount for Non Member', value: 'amount_for_non_member', sortable: false},
      {text: 'Status', value: 'status', sortable: false},
      {text: 'Action', value: 'action', sortable: false},
    ],
  }
}

export default {
  props: {
    for_update: Boolean,
    information_details: Object,
  },
  components: {
    snackBarDialog,
  },
  setup() {
    return {
      icons: {
        mdiAlertOutline,
        mdiCloudUploadOutline,
        mdiPencil,
        mdiDelete,
        mdiCheck,
      },
    }
  },

  data() {
    return initialState()
  },
  mounted() {
    this.initialize_data()
  },
  computed: {
    ...mapGetters('form_rules', ['rules']),
    ...mapGetters('system_data', ['snackbar', 'snackbar_color', 'snackbar_text', 'company_logo']),
    ...mapGetters('authentication', ['position']),
  },
  methods: {
    ...mapActions('system_data', ['change_snackbar']),
    ...mapActions('type_of_service', ['is_service_already_encoded', 'create_service', 'update_service_info', 'list_of_active_type_of_service','update_service_info','status_service_info']),
    initialize_data() {
      this.data_items = []
      this.list_of_active_type_of_service()
        .then(response => {
          this.data_items = response.data
        })
        .catch(error => {
          this.alert = true
          this.alert_message = error
          this.saving = false
        })
    },
    reset() {
      Object.assign(this.$data, initialState())
      this.initialize_data()
    },
    edit_service(item) {
      this.is_deleting = true
      this.id=item.id
      this.last_name = item.type_of_service
      this.mode = item.mode_of_service
      this.amount_for_non_member = item.amount_for_non_member
      this.amount_for_member = item.amount_for_member
    },
    update_service(item, is_active) {
      this.is_deleting = true
      const data = new FormData()
      data.append('id', item.id);
      data.append('is_active', is_active);
      this.status_service_info(data)
        .then(() => {
          this.reset()
        })
        .catch(error => {
          this.alert = true
          this.alert_message = error
          this.saving = false
        })
    },
    save_employee() {
      this.saving = true
      this.alert = false
      if (this.$refs.form.validate()) {
        var proceed = true;
        if (proceed) {
          const data = new FormData()
          data.append('type_of_service', this.last_name.toUpperCase());
          data.append('amount_for_non_member', this.amount_for_non_member);
          data.append('amount_for_member', this.amount_for_member);
          data.append('mode_of_service', this.mode);
          this.is_service_already_encoded(data)
            .then(response => {
              if (response.data === 1) {
                this.alert = true
                this.alert_message = 'Service Already Encoded in this Category!'
                this.saving = false
              } else {
                if (!this.is_deleting){
                  this.create_service(data)
                    .then(response => {
                      this.change_snackbar({
                        show: true,
                        color: 'success',
                        text: response.data,
                      })
                      this.reset()
                    })
                    .catch(error => {
                      this.alert = true
                      this.alert_message = error
                      this.saving = false
                    })
                }else{
                  data.append('id', this.id);
                  this.update_service_info(data)
                    .then(response => {
                      this.change_snackbar({
                        show: true,
                        color: 'success',
                        text: response.data,
                      })
                      this.reset()
                    })
                    .catch(error => {
                      this.alert = true
                      this.alert_message = error
                      this.saving = false
                    })
                }
              }
            })
            .catch(error => {
              this.alert = true
              this.alert_message = error
              this.saving = false
            })
        }
      } else {
        this.alert = true
        this.alert_message = 'Please Fill up the field/s'
        this.saving = false
      }
    },
  }
}
</script>
